import { ProductPurchaseRptConstants } from "../constants/ProductPurchaseRptConstants";

export function ProductPurchaseRpt(state = {}, action) {
    switch (action.type) {
        case ProductPurchaseRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case ProductPurchaseRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case ProductPurchaseRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case ProductPurchaseRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case ProductPurchaseRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case ProductPurchaseRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case ProductPurchaseRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}